import { Typography, Link, Box, Divider } from '@mui/material';
import { t } from 'i18next';
import { Link as RouterLink } from 'react-router';
import ArticleMeta from '../../../types/ArticleMeta';
import {
  sendArticleCardClickToGTM,
  articleCardClickTarget,
  articleCardLocation,
} from '../../../utilities/gtm';
import { getDateInWords } from '../../../utilities/dateUtils';
import { JaaRoute } from '../../../utilities/Links';

interface NewsCardProps {
  article: ArticleMeta;
  index: number;
}

export const NewsCard = ({ article, index }: NewsCardProps) => {
  return (
    <Link
      component={RouterLink}
      to={article.getRoute()}
      title={article.title}
      data-testid='article-card-link'
      onClick={() => {
        sendArticleCardClickToGTM(
          article,
          articleCardClickTarget.ARTICLE,
          articleCardLocation.NEWS,
          index,
        );
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        color: 'text.primary',
        '&:hover': { color: 'primary.main' },
        width: '220px',
        flexShrink: 0,
        height: '118px',
        overflow: 'hidden',
        scrollSnapAlign: 'start',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1,
          width: '100%',
        }}
      >
        <Typography
          variant='overline'
          sx={{
            fontWeight: 'bold',
            color: 'text.secondary',
          }}
        >
          {getDateInWords(article.releaseDate)}
        </Typography>
        <Divider sx={{ flexGrow: 1, ml: 1 }} />
      </Box>
      <Typography
        variant='h5'
        component='h3'
        sx={{
          fontWeight: 'bold',
          display: '-webkit-box',
          WebkitLineClamp: 4,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          overflowWrap: 'break-word',
          textOverflow: 'ellipsis',
        }}
      >
        {article.title}
      </Typography>
    </Link>
  );
};

export const LastCard: React.FC = () => (
  <Link
    component={RouterLink}
    to={JaaRoute.newsIndex}
    title={t('news.viewAll')}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      textDecoration: 'none',
      color: 'text.primary',
      '&:hover': { color: 'primary.main' },
      width: '220px',
      flexShrink: 0,
      height: '118px',
      overflow: 'hidden',
      mr: 4,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        width: '100%',
      }}
    >
      <Typography
        variant='overline'
        sx={{
          fontWeight: 'bold',
          color: 'text.secondary',
        }}
      >
        {t('news.older')}
      </Typography>
      <Divider sx={{ flexGrow: 1, ml: 1 }} />
    </Box>
    <Typography
      variant='h5'
      component='h3'
      sx={{
        fontWeight: 'bold',
        display: '-webkit-box',
        WebkitLineClamp: 4,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {t('news.viewAll')}
    </Typography>
  </Link>
);
